import React, { useState } from 'react';
import ShoppingCart from '../../utils/shoppingCart';
import Button from '../common/Button';

const AddToCartButton = props => {
  const [disabled, setDisabled] = useState(false);

  return (
    <Button
      className="w-full"
      iconClass={`fas ${disabled ? 'fa-check' : 'fa-cart-plus'}`}
      onClick={() => {
        setDisabled(true);
        ShoppingCart.addShoppingCartCard(props.card, props.price);
      }}
      disabled={disabled}>
      {disabled ? 'Agregado al carrito' : 'Agregar al carrito'}
    </Button>
  );
};

export default AddToCartButton;
